import { mergeQuoteRequirements } from "./mergeQuoteRequirements";

const formatDisplayDate = (value) => {
  if (!value) return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return String(value);
  return parsed.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatIsoList = (isoDates = []) =>
  isoDates
    .map((iso) => formatDisplayDate(iso))
    .filter(Boolean)
    .join(", ");

const getAnswerValue = (quote, label) => {
  const fromStored = quote?.conversationalAnswers?.find(
    (item) => item?.label === label
  )?.value;
  return fromStored || "";
};

/**
 * Maps a quote document to the fields shown in ConversationalQuote summary.
 */
export function formatQuoteFormData(quote) {
  if (!quote) return null;

  const ceremonies = getAnswerValue(quote, "Ceremonies");
  const addons = getAnswerValue(quote, "Add-ons");
  const coverage = mergeQuoteRequirements({
    requirements: quote.requirements,
    photographyRequirements: quote.photographyRequirements,
    ceremonies,
    addons,
  });

  let editing = "";
  if (quote.editingPreferences === true) editing = "Yes";
  else if (quote.editingPreferences === false) editing = "No";

  const eventDatesAnswer = getAnswerValue(quote, "Event dates");
  const eventSpan = quote.eventSpan || getAnswerValue(quote, "Event span");

  let date =
    eventDatesAnswer ||
    (quote.selectedEventDates?.length
      ? formatIsoList(quote.selectedEventDates)
      : "") ||
    formatDisplayDate(quote.startDate || quote.eventDate || quote.endDate);

  if (!date && quote.startDate && quote.endDate) {
    const start = formatDisplayDate(quote.startDate);
    const end = formatDisplayDate(quote.endDate);
    date = start === end ? start : `${start} – ${end}`;
  }

  return {
    name: quote.clientName || "",
    budget: quote.budget || quote.currentBudget || "",
    date,
    eventSpan,
    city: quote.city || quote.location || quote.address || "",
    coverage,
    editing,
    ceremonies,
    addons,
    notes: quote.additionalDetails || getAnswerValue(quote, "Notes"),
  };
}

export default formatQuoteFormData;
